<template>
  <div
    :class="[$style.formContainer, $style[`${mfaType}Container`]]"
    data-test-id="UserResetPassword__FormContainer"
  >
    <component
      @error="onError"
      :errorMessage="errorMessage"
      :factors="factors"
      :form="form"
      :is="componentName"
      :mfaType="mfaType"
      :requestKey="requestKey"
      @resetErrorMessage="onResetErrorMessage"
      @resetForm="onResetForm"
      @setErrorMessage="setErrorMessage"
      @success="onSuccess"
    />
    <LogoIcon
      :class="$style[`${mfaType}LogoPosition`]"
    />
  </div>
</template>

<script>
// Components
import LogoIcon from 'client/components/LogoIcon.vue';
import UserResetPasswordInputHandler from 'client/containers/user/UserResetPassword/UserResetPasswordInputHandler.vue';
import UserResetPasswordMfaController from 'client/containers/user/UserResetPassword/UserResetPasswordMfaController.vue';

// Constants
import { LoginConsts } from 'client/util/Constants';

// Service Errors
import MfaRequiredError from 'client/services/response/MfaRequiredError';
import RequestError from 'client/services/response/RequestError';

// Utils
import getCurrentComponentNameFromList from 'client/containers/user/MfaComponents/mfaUtils/getCurrentComponentNameFromList';
import mfaFactorBuilder from 'client/containers/user/MfaComponents/mfaUtils/mfaFactorBuilder';
import routes from 'client/routes/RouteGenerator';

const { login } = routes;
const {
  responseMessages: {
    mfaUnavailableForPwdReset,
    passwordResetError,
    passwordResetSuccess,
  },
} = LoginConsts;

const componentsUnderControl = [
  {
    id: '',
    componentName: UserResetPasswordInputHandler.name,
  },
  {
    id: 'mfa',
    componentName: UserResetPasswordMfaController.name,
  },
];

const getCurrentComponentName = getCurrentComponentNameFromList(componentsUnderControl);

const formInitialState = {
  password: '',
  confirm: '',
};

export default {
  name: 'UserResetPasswordController',

  components: {
    LogoIcon,
    UserResetPasswordInputHandler,
    UserResetPasswordMfaController,
  },

  props: {
    mfaType: {
      type: String,
      default: '',
    },
    requestKey: {
      type: String,
      default: '',
    },
    step: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      errorMessage: '',
      factors: [],
      form: {
        ...formInitialState,
      },
    };
  },

  computed: {
    componentName() {
      return getCurrentComponentName(this.step);
    },

    controllingQueryParams() {
      return {
        template: 'resetPasswordUserForm',
        key: this.requestKey,
      };
    },
  },

  mounted() {
    this.validateInitialStep();
  },

  methods: {
    onError(error) {
      if (error instanceof RequestError) {
        return this.setErrorMessage(error.message);
      }
      if (!(error instanceof MfaRequiredError)) {
        return this.setErrorMessage(passwordResetError);
      }

      this.factors = mfaFactorBuilder(
        {
          factors: error.factors,
        },
        {
          controllingQueryParams: this.controllingQueryParams,
        },
      );

      if (this.factors.length === 0) {
        return this.setErrorMessage(mfaUnavailableForPwdReset);
      }

      this.form.challenge = error.challenge;
      this.form.pwdResetToken = error.pwdResetToken;

      return this.$router.push({ path: login, query: { ...this.controllingQueryParams, step: 'mfa' } });
    },

    onResetErrorMessage() {
      this.setErrorMessage();
    },

    onResetForm() {
      this.form = {
        ...formInitialState,
      };
    },

    onSuccess() {
      this.$router.push({ name: 'Login', params: { success: passwordResetSuccess } });
    },

    setErrorMessage(message = '') {
      this.errorMessage = message;
    },

    validateInitialStep() {
      const isInitialStepInvalid = this.step && !this.factors.length;

      if (isInitialStepInvalid) {
        this.$router.replace({ path: login, query: { ...this.controllingQueryParams } });
      }
    },
  },
};
</script>

<style module>
@import '../../../css/login-components.css';

.duoContainer {
  max-width: fit-content;
}

/* Override breakpoint for .logoIconFixed from LogoIcon to account for wider card */
@media (max-width: 1058px) {
  .duoLogoPosition {
    bottom: 0;
    display: block;
    margin: 3rem 0 2rem auto;
    position: relative;
    right: 0;
  }
}
</style>
